export default __webpack_public_path__ + "static/media/826.77839d0c.gif";